import React from 'react';
import ProfileContainer from 'components/Profile';

export default function ProfilePage() {
  return (
    <ProfileContainer />
  );
}

ProfilePage.displayName = 'ProfilePage';
